import { render, staticRenderFns } from "./PuzzleCreate.vue?vue&type=template&id=eb6c4656&"
import script from "./PuzzleCreate.vue?vue&type=script&lang=js&"
export * from "./PuzzleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports